module.exports = __webpack_public_path__ + "media/images/gallery/gc_l-1579748350a1a53de2735b5c5f860167.gif";